import { AgGridColumnProps } from "ag-grid-react";
import { asCurrency, asDate } from "lqx-react/src";
import { getAssetErrors, getAssetStatus, getCellColor } from "../components/assets-table";
import { asTimelessDateUTC } from "lqx-react/lib";

export enum FilterName {
    Amount = 'amounts',
    PayorCompany = 'payorCompanies',
    ReferenceNumber = 'referenceNumbers',
    PayeeCompany = 'payeeCompanies',
    Currency = 'currencies',
    EffectiveDate = 'effectiveDates'
}


export enum FilterTypeUnappliedCashes {
    All = 0,
    ValidationCategory,
    AssetState,
    PayorCompany,
    PayeeCompany,
    ReferenceNumber,
    Amount,
    Currency,
    EffectiveDate
}

export enum UnappliedCashesSortingBase {
    Id = 0,
    CreatedOn,
    UpdatedOn,
    ValidationCategory,
    AssetState,
    PayorCompany,
    PayeeCompany,
    ReferenceNumber,
    Amount,
    Currency,
    EffectiveDate
}

export enum UnappliedCashesTableColumns {
    Status = 0,
    PayorCompany,
    PayeeCompany,
    ReferenceNumber,
    Amount,
    Currency,
    EffectiveDate,
    Errors
}

export const UnappliedCashTableColumns: AgGridColumnProps[] = [
    {
        colId: 'CheckBox',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true
    },
    {
        colId: UnappliedCashesTableColumns.Status.toString(),
        headerName: "Status",
        filter: 'agSetColumnFilter',
        filterParams: {
            values: ['Pass Validation - New', 'Pass Validation - Modified', 'Require Review', 'Duplicated', 'Conflict', 'Saved for Later', 'Digitized', 'Modifies Existing']
        },
        valueGetter: params => getAssetStatus(params.data),
        cellStyle: params => { return { color: getCellColor(params.data) } },
        sortable: true
    },
    {
        colId: UnappliedCashesTableColumns.Errors.toString(),
        headerName: "Errors",
        valueGetter: params => getAssetErrors(params.data)
    },
    {
        colId: UnappliedCashesTableColumns.PayorCompany.toString(),
        headerName: "Payor Company",
        field: "changes.payor.company.name",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: UnappliedCashesTableColumns.PayeeCompany.toString(),
        headerName: "Payee Company",
        field: "changes.payee.company.name",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: UnappliedCashesTableColumns.ReferenceNumber.toString(),
        headerName: "Reference Number",
        field: "changes.referenceNumber",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: UnappliedCashesTableColumns.Amount.toString(),
        headerName: "Amount",
        field: "changes.amount",
        cellStyle: { textAlign: "right" },
        valueFormatter: asCurrency,
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: UnappliedCashesTableColumns.Currency.toString(),
        headerName: "Currency",
        field: "changes.currency",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    },
    {
        colId: UnappliedCashesTableColumns.EffectiveDate.toString(),
        headerName: "Effective Date",
        field: "changes.effectiveDate",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        valueFormatter: asTimelessDateUTC,
        sortable: true
    }
]
